<template>
    <v-card>
        <v-chip>dsfsd</v-chip>
    </v-card>
</template>
<script>
export default {
    name: 'PersonalDataHelp'
}
</script>